import {
  cloudOrganizationPath,
  samlProviderPath,
} from "app/views/settings/access-control/IdentityProviders/constants";

import type { CloudProvider } from "app/views/settings/access-control/IdentityProviders/__generated__/CloudOrganizationCard_organization.graphql";

/** The dimension a users table is grouped by. */
export type UserGroupingKind = "group" | "role" | "identity-provider";

/**
 * The search term the directory threads through each grouping so it survives a
 * group-by switch, which swaps one grid for another. Composed into every
 * grouping's props and the grid's.
 */
export interface RetainedSearch {
  /** Seed applied once on mount. */
  initialSearchTerm?: string;
  /** Reports the applied term back to the directory. */
  onSearchTermChange?: (term: string) => void;
}

/** One bucket in a grouped users table — enough to label it and link to its details. */
export type UserGrouping =
  | {
      kind: "group";
      /** The group's stable uuid — the detail route param. */
      uuid: string;
      /** Group name, for the header label. */
      name: string;
    }
  | {
      kind: "role";
      /** Role name, for the header label. */
      name: string;
    }
  | ({
      kind: "identity-provider";
      /** Provider display name (alias or name), for the header label. */
      displayName: string;
    } & (
      | { providerKind: "saml"; name: string }
      | {
          providerKind: "cloud-organization";
          provider: CloudProvider;
          key: string;
        }
    ));

/** A bucket's details-page path, or null when it has none (roles have no page). */
export function groupingDetailPath(grouping: UserGrouping): string | null {
  switch (grouping.kind) {
    case "group":
      return `/settings/access-control/groups/${grouping.uuid}`;
    case "identity-provider":
      return grouping.providerKind === "saml"
        ? samlProviderPath(grouping.name)
        : cloudOrganizationPath(grouping.provider, grouping.key);
    case "role":
      return null;
  }
}
